import React, { useEffect, useRef, useState } from "react";
import { translateText, translateLabel, useTranslationSnapshot } from "./../../translations/runtime";


const modalCopy = {
  add: {
    title: "Add Funds",
    subtitle: "Add funds to your Digital Wallet.",
    label: "Amount to Add",
    info: "Funds will be added to your wallet after successful payment confirmation.",
    closeLabel: "Close Add Funds modal",
    titleId: "digital-wallet-add-funds-title",
    amountId: "digital-wallet-add-funds-amount",
  },
  withdraw: {
    title: "Withdraw Funds",
    subtitle: "Withdraw funds to your Digital Wallet.",
    label: "Amount Withdraw",
    info: "Funds will be deducted from your wallet after successful payment confirmation.",
    closeLabel: "Close Withdraw Funds modal",
    titleId: "digital-wallet-withdraw-funds-title",
    amountId: "digital-wallet-withdraw-funds-amount",
  },
};

function WalletFundsModal({ visible, mode = "add", onClose, onConfirm }) {
  useTranslationSnapshot();
  const [amount, setAmount] = useState("0.00");
  const amountInputRef = useRef(null);
  const copy = modalCopy[mode] || modalCopy.add;

  useEffect(() => {
    if (!visible) {
      return undefined;
    }

    setAmount("0.00");
    window.setTimeout(() => amountInputRef.current?.select(), 0);

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [visible, onClose]);

  if (!visible) {
    return null;
  }

  const numericAmount = Number(amount);
  const isConfirmDisabled =
    !amount ||
    Number.isNaN(numericAmount) ||
    numericAmount <= 0;

  const handleAmountChange = (event) => {
    const nextAmount = event.target.value;

    if (!/^\d*\.?\d{0,2}$/.test(nextAmount)) {
      return;
    }

    setAmount(nextAmount);
  };
  const selectAmount = (event) => event.target.select();

  const handleConfirm = () => {
    if (isConfirmDisabled) {
      return;
    }

    onConfirm?.(numericAmount);
  };

  return (
    <div className="digital-wallet-funds-overlay" onClick={onClose}>
      <div
        className="digital-wallet-funds-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby={copy.titleId}
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="digital-wallet-funds-close"
          aria-label={translateText(copy.closeLabel)}
          onClick={onClose}
        >
          <span aria-hidden="true">&times;</span>
        </button>

        <div className="digital-wallet-funds-heading">
          <div className="digital-wallet-funds-title" id={copy.titleId}>
            {translateText(copy.title)}
          </div>
          <div className="digital-wallet-funds-subtitle">{translateText(copy.subtitle)}</div>
        </div>

        <div className="digital-wallet-funds-field">
          <label htmlFor={copy.amountId}>{translateText(copy.label)}</label>
          <div className="digital-wallet-funds-input-wrap">
            <input
              ref={amountInputRef}
              id={copy.amountId}
              type="text"
              inputMode="decimal"
              value={amount}
              onChange={handleAmountChange}
              onClick={selectAmount}
              onFocus={selectAmount}
              aria-label={translateText(copy.label)}
              autoFocus
            />
            <div className="digital-wallet-funds-currency">{translateLabel("txt_currency_usd", "USD")}</div>
          </div>
        </div>
        <div className="digital-wallet-funds-info">
          <div className="digital-wallet-funds-info-icon" aria-hidden="true">
            i
          </div>
          <div className="digital-wallet-funds-info-text">{copy.info}</div>
        </div>

        <button
          type="button"
          className="digital-wallet-funds-confirm"
          disabled={isConfirmDisabled}
          onClick={handleConfirm}
        > {translateLabel("btn_confirm", "Confirm")} </button>

        <div className="digital-wallet-funds-secure">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M12 21C12 21 20 17 20 11V5L12 2L4 5V11C4 17 12 21 12 21Z"
              stroke="#ff9800"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.5 12L11 14.5L16 9.5"
              stroke="#ff9800"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <div>{translateLabel("txt_admin_secure_payment", "Secure Payment")}</div>
        </div>
      </div>
    </div>
  );
}

export default WalletFundsModal;







